export const pageInitiallyRenderedClassName = 'pageInitiallyRendered';
export const pageNotLoadedClassName = 'pageNotLoaded';

export const wrongVersionErrorClassName = 'wrongVersionError';
